import { Box, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

const DetailPanel = ({
  payer,
  email,
  paymentId,
}: {
  payer: string;
  email?: string;
  paymentId?: string;
}) => (
  <Box margin={1}>
    <Table size="small" aria-label="additional rtp details">
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox" />
          <TableCell>Payer</TableCell>
          <TableCell>Payer Email</TableCell>
          {paymentId ? <TableCell>MH Transaction ID</TableCell> : null}
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell padding="checkbox" />
          <TableCell>{payer}</TableCell>
          <TableCell>{email}</TableCell>
          {paymentId ? <TableCell>{paymentId}</TableCell> : null}
        </TableRow>
      </TableBody>
    </Table>
  </Box>
);

export default DetailPanel;
